import { registerProblemMessages } from '@masar/i18n';
import { consoleProblems } from '@masar/i18n/problems/console';

/**
 * People-facing messages for the problem codes of the desk, the insights
 * pages, WhatsApp messages and the invite page. The setup and counter pages
 * register their own when they load.
 */
registerProblemMessages(consoleProblems);
